export const genPreviewFromVideoCmd = ({
  input,
  output,
  width,
  height,
}: {
  input: string;
  output: string;
  width: number;
  height: number;
}) => [
  '-i',
  input,
  '-ss',
  '00:00:01.000',
  '-vf',
  `scale=${width / 2}:${
    height / 2
  }:force_original_aspect_ratio=decrease`,
  '-vframes',
  '1',
  output,
];
